import routerConstants from '@/constants/routerConstants'
import { runNhomHangVisualTest } from '@/modules/test-module-chitiet/tester/nhomHangVisualTest'
import { MODULE_VISUAL_SCENARIOS } from '@/modules/test-module-chitiet/tester/moduleVisualScenarios'
import type { VisualRun } from '@/modules/test-module-chitiet/tester/visualTestKit'
import type { UiTestScenarioId } from '@/modules/ui-test/uiTest.types'
import type { UiTestRunner } from '@/modules/ui-test/utils/uiTestRunner'
import { UI_TEST_SCENARIOS } from '@/modules/ui-test/scenarioRegistry'

export const UI_TESTER_QUERY = 'uiTester'

export type VisualTesterDef = {
  scenarioId: UiTestScenarioId
  label: string
  listPath: string
  featureCount: number
  run: (uiTest: UiTestRunner) => Promise<VisualRun>
}

const fromModules = Object.fromEntries(
  Object.entries(MODULE_VISUAL_SCENARIOS).map(([id, def]) => [
    id,
    {
      scenarioId: id as UiTestScenarioId,
      label: def.label,
      listPath: def.listPath,
      featureCount: def.featureCount,
      run: def.run,
    } satisfies VisualTesterDef,
  ]),
) as Record<string, VisualTesterDef>

export const VISUAL_TESTERS: Record<UiTestScenarioId, VisualTesterDef> = {
  ...(fromModules as Record<UiTestScenarioId, VisualTesterDef>),
  'nhom-hang': {
    scenarioId: 'nhom-hang',
    label: 'Nhóm hàng',
    listPath: routerConstants.nhomHang.list,
    featureCount: 11,
    run: async (uiTest) => {
      const result = await runNhomHangVisualTest(uiTest)
      return { summary: result.summary, shots: result.shots }
    },
  },
}

// Đảm bảo mọi scenario trong registry đều có tester.
for (const id of Object.keys(UI_TEST_SCENARIOS) as UiTestScenarioId[]) {
  if (!VISUAL_TESTERS[id]) {
    const scenario = UI_TEST_SCENARIOS[id]
    VISUAL_TESTERS[id] = {
      scenarioId: id,
      label: id,
      listPath: scenario.targetPath,
      featureCount: 2,
      run: fromModules[id]?.run ?? MODULE_VISUAL_SCENARIOS['don-vi-tinh' as keyof typeof MODULE_VISUAL_SCENARIOS].run,
    }
  }
}

export function getVisualTester(id: string | null | undefined): VisualTesterDef | null {
  if (!id) return null
  return VISUAL_TESTERS[id as UiTestScenarioId] ?? null
}

export function buildVisualTesterUrl(scenarioId: UiTestScenarioId): string {
  const def = VISUAL_TESTERS[scenarioId]
  if (!def?.listPath) throw new Error(`Chưa có Test UI cho: ${scenarioId}`)
  const qIndex = def.listPath.indexOf('?')
  const path = qIndex >= 0 ? def.listPath.slice(0, qIndex) : def.listPath
  const baseQs = qIndex >= 0 ? def.listPath.slice(qIndex + 1) : ''
  const qs = new URLSearchParams(baseQs)
  qs.set(UI_TESTER_QUERY, scenarioId)
  return `${path}?${qs.toString()}`
}

export function buildNhomHangVisualTesterUrl(): string {
  return buildVisualTesterUrl('nhom-hang')
}

export const VISUAL_TESTER_SCENARIO_IDS = Object.keys(VISUAL_TESTERS) as UiTestScenarioId[]
